<template>
  <UnavailableError>
    <template #hat="{ hat }">
      <p class="text-h1">
        {{ hat }}
      </p>
    </template>
  </UnavailableError>
</template>

<script setup lang="ts">
import { UnavailableError } from "@pasta/box-v2";
</script>
